import React, { useEffect, useState } from 'react';
import { attendanceAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function AttendancePage() {
  const [summary, setSummary] = useState([]);
  const [month, setMonth] = useState(new Date().toISOString().substring(0,7));
  const [loading, setLoading] = useState(false);
  const [checkStatus, setCheckStatus] = useState('');
  const [actionLoading, setActionLoading] = useState('');
  const { user } = useAuth();
  const isHR = ['admin','hr_manager','hr_staff'].includes(user?.role);

  const load = () => {
    setLoading(true);
    attendanceAPI.summary(month).then(r => setSummary(r.data.data)).finally(() => setLoading(false));
  };

  useEffect(() => { if (isHR) load(); }, [month]);

  const handleCheckIn = async () => {
    setActionLoading('in');
    try {
      await attendanceAPI.checkIn('web');
      setCheckStatus('✅ Check-in thành công lúc ' + new Date().toLocaleTimeString('vi-VN'));
    } catch (err) {
      setCheckStatus('❌ ' + (err.response?.data?.message || 'Lỗi check-in'));
    } finally {
      setActionLoading('');
    }
  };

  const handleCheckOut = async () => {
    setActionLoading('out');
    try {
      await attendanceAPI.checkOut();
      setCheckStatus('✅ Check-out thành công lúc ' + new Date().toLocaleTimeString('vi-VN'));
    } catch (err) {
      setCheckStatus('❌ ' + (err.response?.data?.message || 'Lỗi check-out'));
    } finally {
      setActionLoading('');
    }
  };

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>⏱️ Quản lý chấm công</h1>

      {/* Employee check-in panel */}
      <div style={{ background: 'linear-gradient(135deg,#1e3a8a,#0891b2)', borderRadius: 12, padding: 24, color: '#fff', marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>Chấm công hôm nay</div>
            <div style={{ opacity: 0.85, fontSize: 14 }}>
              {new Date().toLocaleDateString('vi-VN', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' })}
            </div>
            {checkStatus && (
              <div style={{ marginTop: 10, background: 'rgba(255,255,255,0.2)', padding: '8px 14px', borderRadius: 8, fontSize: 14 }}>
                {checkStatus}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <button onClick={handleCheckIn} disabled={actionLoading === 'in'} style={{
              padding: '14px 28px', background: actionLoading === 'in' ? '#4ade80' : '#22c55e',
              border: 'none', borderRadius: 10, color: '#fff', fontWeight: 700, fontSize: 16,
              cursor: actionLoading === 'in' ? 'not-allowed' : 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
            }}>
              {actionLoading === 'in' ? '⏳ Đang ghi...' : '📍 Check-in'}
            </button>
            <button onClick={handleCheckOut} disabled={actionLoading === 'out'} style={{
              padding: '14px 28px', background: 'rgba(255,255,255,0.2)', border: '2px solid rgba(255,255,255,0.5)',
              borderRadius: 10, color: '#fff', fontWeight: 700, fontSize: 16,
              cursor: actionLoading === 'out' ? 'not-allowed' : 'pointer',
              opacity: actionLoading === 'out' ? 0.7 : 1,
            }}>
              {actionLoading === 'out' ? '⏳ Đang ghi...' : '🏁 Check-out'}
            </button>
          </div>
        </div>
      </div>

      {isHR && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, color: '#1e293b', margin: 0 }}>Bảng tổng hợp chấm công</h2>
            <input type="month" value={month} onChange={e => setMonth(e.target.value)}
              style={{ padding: '7px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14 }} />
          </div>

          <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                  {['Mã NV', 'Họ tên', 'Phòng ban', 'Ngày đi làm', 'Đi muộn', 'Vắng', 'Giờ OT', 'Tổng giờ làm'].map(h => (
                    <th key={h} style={{ padding: '12px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={8} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>⏳ Đang tải...</td></tr>
                ) : summary.map((row, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f8fafc' }}>
                    <td style={{ padding: '10px 14px', fontFamily: 'monospace', fontSize: 12, color: '#1e3a8a', fontWeight: 600 }}>{row.employee_code}</td>
                    <td style={{ padding: '10px 14px', fontWeight: 500, color: '#1e293b' }}>{row.name}</td>
                    <td style={{ padding: '10px 14px', color: '#64748b' }}>{row.department}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                      <span style={{ fontWeight: 700, color: '#1e293b' }}>{row.present_days || 0}</span>
                    </td>
                    <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                      {row.late_days > 0 ? (
                        <span style={{ background: '#fef9c3', color: '#ca8a04', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 }}>{row.late_days}</span>
                      ) : <span style={{ color: '#94a3b8' }}>0</span>}
                    </td>
                    <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                      {row.absent_days > 0 ? (
                        <span style={{ background: '#fee2e2', color: '#dc2626', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 }}>{row.absent_days}</span>
                      ) : <span style={{ color: '#94a3b8' }}>0</span>}
                    </td>
                    <td style={{ padding: '10px 14px', textAlign: 'center', color: row.total_ot_hours > 0 ? '#7c3aed' : '#94a3b8', fontWeight: row.total_ot_hours > 0 ? 600 : 400 }}>
                      {parseFloat(row.total_ot_hours || 0).toFixed(1)}h
                    </td>
                    <td style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 500 }}>
                      {parseFloat(row.total_worked_hours || 0).toFixed(1)}h
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
